// The customer's words, in English, Hindi and Kannada. Drafts: a native speaker checks each before a release.
// Project and brand names stay in English inside the Indian scripts, as Indian marketing usually has them.
export const LANGS = [["en", "English"], ["hi", "हिंदी"], ["kn", "ಕನ್ನಡ"]];

const T = {
  following: { en: "Following {host}", hi: "{host} के साथ", kn: "{host} ಜೊತೆ" },
  exploring: { en: "Exploring · follow {host}", hi: "ख़ुद देख रहे हैं · {host} के साथ चलें", kn: "ನೀವೇ ನೋಡುತ್ತಿದ್ದೀರಿ · {host} ಜೊತೆ ಬನ್ನಿ" },
  book: { en: "Book site visit", hi: "साइट विज़िट बुक करें", kn: "ಸೈಟ್ ಭೇಟಿ ಬುಕ್ ಮಾಡಿ" },
  booked: { en: "Visit booked", hi: "विज़िट बुक है", kn: "ಭೇಟಿ ಬುಕ್ ಆಗಿದೆ" },
  cost: { en: "Cost sheet", hi: "कॉस्ट शीट", kn: "ಕಾಸ್ಟ್ ಶೀಟ್" },
  ask: { en: "Ask", hi: "पूछें", kn: "ಕೇಳಿ" },
  leave: { en: "Leave", hi: "छोड़ें", kn: "ಹೊರಡಿ" },
  lookAround: { en: "Drag to look around", hi: "चारों ओर देखने के लिए खींचें", kn: "ಸುತ್ತ ನೋಡಲು ಎಳೆಯಿರಿ" },
  showing: { en: "{host} is showing {scene} — tap the tour to see it", hi: "{host} {scene} दिखा रहे हैं — देखने के लिए टूर पर टैप करें", kn: "{host} {scene} ತೋರಿಸುತ್ತಿದ್ದಾರೆ — ನೋಡಲು ಟೂರ್ ಮೇಲೆ ಟ್ಯಾಪ್ ಮಾಡಿ" },
  sharing: { en: "{host} is sharing a tab", hi: "{host} एक टैब शेयर कर रहे हैं", kn: "{host} ಒಂದು ಟ್ಯಾಬ್ ಹಂಚಿಕೊಳ್ಳುತ್ತಿದ್ದಾರೆ" },
  siteCam: { en: "{host} is showing the site camera, live", hi: "{host} साइट कैमरा लाइव दिखा रहे हैं", kn: "{host} ಸೈಟ್ ಕ್ಯಾಮೆರಾವನ್ನು ನೇರವಾಗಿ ತೋರಿಸುತ್ತಿದ್ದಾರೆ" },
  waiting: { en: "{host} will join in a moment", hi: "{host} बस आ रहे हैं", kn: "{host} ಸ್ವಲ್ಪ ಹೊತ್ತಿನಲ್ಲಿ ಬರುತ್ತಾರೆ" },
};

export function t(key, lang, vars = {}) {
  const s = (T[key] && (T[key][lang] || T[key].en)) || key;
  return s.replace(/\{(\w+)\}/g, (_, k) => vars[k] ?? "");
}

export function pickLang(obj, lang) {
  if (obj == null) return "";
  if (typeof obj === "string") return obj;
  return obj[lang] || obj.en || "";
}
